import { render, staticRenderFns } from "./GroupProgress.vue?vue&type=template&id=5ec930e4&scoped=true&"
import script from "./GroupProgress.vue?vue&type=script&lang=js&"
export * from "./GroupProgress.vue?vue&type=script&lang=js&"
import style0 from "./GroupProgress.vue?vue&type=style&index=0&id=5ec930e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec930e4",
  null
  
)

export default component.exports